var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_244_192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.625 3.06665C11.203 3.25002 10.7565 3.37082 10.2996 3.42525C10.7798 3.14409 11.1409 2.69741 11.3152 2.169C10.8612 2.43445 10.3654 2.6207 9.8489 2.71978C9.63142 2.49186 9.36987 2.31054 9.08014 2.18684C8.7904 2.06315 8.47854 1.99967 8.16351 2.00025C6.88804 2.00025 5.85586 3.01743 5.85586 4.27134C5.85495 4.44575 5.87494 4.61965 5.91539 4.78931C5.00078 4.74643 4.1052 4.51312 3.28593 4.10429C2.46666 3.69546 1.74175 3.12013 1.15758 2.41509C0.952634 2.76059 0.844249 3.15479 0.84375 3.5565C0.84375 4.344 1.25461 5.04009 1.875 5.4479C1.50744 5.43918 1.1474 5.34189 0.825469 5.16431V5.19243C0.825469 6.29399 1.62234 7.2104 2.67703 7.41899C2.4787 7.47186 2.27432 7.49865 2.06906 7.49868C1.92342 7.49894 1.7781 7.4848 1.63523 7.45649C1.92844 8.35884 2.7818 9.01509 3.79265 9.03384C2.97126 9.66687 1.9628 10.009 0.925781 10.0065C0.741707 10.0062 0.557804 9.99526 0.375 9.97368C1.42996 10.6473 2.65628 11.0036 3.90797 11.0002C8.15859 11.0002 10.4808 7.53853 10.4808 4.53618C10.4808 4.43775 10.4782 4.33931 10.4735 4.24322C10.9242 3.9226 11.3142 3.52418 11.625 3.06665Z",
    fill: "#5030E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_244_192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.00012207 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.466b11d0bdb6dc592ff83f041822290d.svg";
export { ForwardRef as ReactComponent };